import { render, staticRenderFns } from "./AsignacionBusqueda.vue?vue&type=template&id=240124a5&"
import script from "./AsignacionBusqueda.vue?vue&type=script&lang=ts&"
export * from "./AsignacionBusqueda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports